/**
 * @generated SignedSource<<3c35ee90aa4126eb010ec06906bafd7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "billingGroupId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "firstName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lastName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locationName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "npi"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tin"
  }
],
v1 = {
  "kind": "Variable",
  "name": "billingGroupId",
  "variableName": "billingGroupId"
},
v2 = {
  "kind": "Variable",
  "name": "firstName",
  "variableName": "firstName"
},
v3 = {
  "kind": "Variable",
  "name": "lastName",
  "variableName": "lastName"
},
v4 = {
  "kind": "Variable",
  "name": "locationName",
  "variableName": "locationName"
},
v5 = {
  "kind": "Variable",
  "name": "npi",
  "variableName": "npi"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BillingGroupPractitionersTableRefetch",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "tin",
            "variableName": "tin"
          }
        ],
        "kind": "FragmentSpread",
        "name": "BillingGroupPractitionersTableFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BillingGroupPractitionersTableRefetch",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "tIN",
                "variableName": "tin"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "Practitioner",
        "kind": "LinkedField",
        "name": "filteredPractitioners",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PractitionerIdentifier",
            "kind": "LinkedField",
            "name": "identifiers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IdentifierType",
                "kind": "LinkedField",
                "name": "identifierType",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PractitionerVersion",
            "kind": "LinkedField",
            "name": "applicableVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b20fcff6c549eb47872c8552f1e08c64",
    "id": null,
    "metadata": {},
    "name": "BillingGroupPractitionersTableRefetch",
    "operationKind": "query",
    "text": "query BillingGroupPractitionersTableRefetch(\n  $billingGroupId: ID = null\n  $firstName: String = null\n  $lastName: String = null\n  $locationName: String = null\n  $npi: String = null\n  $tin: String = null\n) {\n  ...BillingGroupPractitionersTableFragment_4u7Et7\n}\n\nfragment BillingGroupPractitionersTableFragment_4u7Et7 on Query {\n  filteredPractitioners(input: {firstName: $firstName, lastName: $lastName, npi: $npi, tIN: $tin, billingGroupId: $billingGroupId, locationName: $locationName}) {\n    id\n    identifiers {\n      identifierType {\n        code\n        id\n      }\n      value\n      id\n    }\n    applicableVersion {\n      displayName\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "f9f5672df143d277810e7a8f7df43d70";

export default node;
